'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ComplexInput = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp, _initialiseProps;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _form = require('antd/lib/form');

var _form2 = _interopRequireDefault(_form);

var _row = require('antd/lib/row');

var _row2 = _interopRequireDefault(_row);

var _col = require('antd/lib/col');

var _col2 = _interopRequireDefault(_col);

var _icon = require('antd/lib/icon');

var _icon2 = _interopRequireDefault(_icon);

var _input = require('antd/lib/input');

var _input2 = _interopRequireDefault(_input);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var formItemLayout = {
  wrapperCol: { span: 24 },
  required: false,
  style: { margin: '0 10px 10px 0' }
};
var formItemLayoutTwo = {
  labelCol: {
    xs: { span: 2 },
    sm: { span: 2 }
  },
  wrapperCol: {
    xs: { span: 2 },
    sm: { span: 22 }
  },
  style: { margin: '0 10px 10px 0' }
};

var ComplexInput = exports.ComplexInput = (_dec = _form2.default.create(), _dec(_class = (_temp = _class2 = function (_React$PureComponent) {
  _inherits(ComplexInput, _React$PureComponent);

  function ComplexInput(props) {
    _classCallCheck(this, ComplexInput);

    var _this = _possibleConstructorReturn(this, (ComplexInput.__proto__ || Object.getPrototypeOf(ComplexInput)).call(this, props));

    _initialiseProps.call(_this);

    var value = _this.convert(props.value || '');
    _this._uuid = 0;
    _this._oValue = props.value;
    _this.state = {
      value: value,
      keys: Array.isArray(value) && value.length ? value.map(function () {
        return _this._uuid++;
      }) : [_this._uuid++]
    };
    return _this;
  }

  _createClass(ComplexInput, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (nextProps.value !== this._oValue) {
        this._oValue = nextProps.value;
        var value = this.convert(nextProps.value || '');
        this._uuid = 0;
        this.setState({
          value: value,
          keys: Array.isArray(value) && value.length ? value.map(function () {
            return _this2._uuid++;
          }) : [this._uuid++]
        });
      }
    }
  }, {
    key: 'convert',
    value: function convert(v, inverse) {
      var _props = this.props,
          convert = _props.convert,
          separator = _props.separator,
          delimeter = _props.delimeter;

      if (convert) {
        return convert(v, inverse);
      } else if (separator) {
        if (inverse) {
          v = delimeter ? v.map(function (d) {
            return d.join(delimeter);
          }) : v;
          return v.join(separator);
        } else {
          v = v.split(separator);
          return delimeter ? v.map(function (d) {
            return d.split(delimeter);
          }) : v;
        }
      } else {
        return [].concat(v || []);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var keys = this.state.keys;
      return this.props.showBorder ? _react2.default.createElement(
        'div',
        { style: {
            border: '1px solid #ddd',
            padding: 10
          } },
        _react2.default.createElement(
          _form2.default,
          null,
          keys.map(this.getItem)
        )
      ) : _react2.default.createElement(
        _form2.default,
        null,
        keys.map(this.getItem)
      );
    }
  }]);

  return ComplexInput;
}(_react2.default.PureComponent), _class2.propTypes = {
  form: _propTypes2.default.object,
  separator: _propTypes2.default.string,
  delimeter: _propTypes2.default.string,
  inputs: _propTypes2.default.array,
  disabled: _propTypes2.default.bool,
  extra: _propTypes2.default.string,
  convert: _propTypes2.default.func,
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array]),
  onChange: _propTypes2.default.func,
  showIcon: _propTypes2.default.bool,
  showBorder: _propTypes2.default.bool,
  showLine: _propTypes2.default.string,
  span: _propTypes2.default.number,
  keyName: _propTypes2.default.number
}, _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.remove = function (k) {
    var keys = _this3.state.keys;
    // can use data-binding to get
    // We need at least one passenger

    if (keys.length === 1) {
      return;
    }

    // can use data-binding to set
    _this3.setState({
      keys: keys.filter(function (key) {
        return key !== k;
      })
    });
  };

  this.add = function () {
    var keys = _this3.state.keys;
    // can use data-binding to get

    var nextKeys = keys.concat(_this3._uuid);
    _this3._uuid++;
    // keys.splice(idx, 0, this._uuid++);

    // can use data-binding to set
    // important! notify form to detect changes
    _this3.setState({
      keys: nextKeys
    });
  };

  this.handleChange = function () {
    clearTimeout(_this3._timer);
    _this3._timer = setTimeout(function () {
      _this3.props.form.validateFields(function (err, values) {
        if (!err) {
          var body = _this3.state.keys.map(function (k) {
            return _this3.props.inputs.length > 1 ? _this3.props.inputs.map(function (inp, index) {
              return values['inp' + index][k];
            }) : values['inp0'][k];
          });
          _this3._oValue = _this3.convert(body, true);
          _this3.props.onChange && _this3.props.onChange(_this3._oValue);
        }
      });
    }, 200);
  };

  this.getItem = function (k, index) {
    var keys = _this3.state.keys;
    var _props2 = _this3.props,
        form = _props2.form,
        inputs = _props2.inputs,
        disabled = _props2.disabled,
        extra = _props2.extra;

    var showIcon = _this3.props.showIcon ? _this3.props.showIcon : false;
    var showLine = _this3.props.showLine ? _this3.props.showLine : 'none';
    var value = _this3.state.value[k];
    var span = _this3.props.span ? _this3.props.span : Math.floor(22 / inputs.length);
    var IInput = inputs[0].component || _input2.default;
    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        _row2.default,
        { key: k },
        span < 22 ? inputs.map(function (inp, pos) {
          IInput = inp.component || _input2.default;
          return _react2.default.createElement(
            _col2.default,
            { span: span, key: k + '_' + pos },
            _react2.default.createElement(
              _form2.default.Item,
              _extends({}, formItemLayout, { disabled: disabled }),
              form.getFieldDecorator('inp' + pos + '[' + k + ']', Object.assign({
                initialValue: value ? value[pos] : undefined
              }, inp.rule && {
                validateTrigger: ['onChange', 'onBlur'],
                rules: inp.rule
              }))(_react2.default.createElement(IInput, _extends({}, inp, { onChange: _this3.handleChange })))
            )
          );
        }) : inputs.map(function (inp, pos) {
          IInput = inp.component || _input2.default;
          return _react2.default.createElement(
            _col2.default,
            { span: 22, key: k + '_' + pos },
            _react2.default.createElement(
              _form2.default.Item,
              _extends({}, formItemLayoutTwo, { disabled: disabled, label: inp.label, rules: inp.rules, extra: inp.types ? null : extra }),
              inp.types ? form.getFieldDecorator('inp' + pos + '[' + k + ']', Object.assign({
                initialValue: value ? value[pos] : undefined
              }, inp.rule && {
                validateTrigger: ['onChange', 'onBlur'],
                rules: inp.rule
              }))(_react2.default.createElement(IInput.TextArea, _extends({}, inp, { onChange: _this3.handleChange }))) : form.getFieldDecorator('inp' + pos + '[' + k + ']', Object.assign({
                initialValue: value ? value[pos] : undefined
              }, inp.rule && {
                validateTrigger: ['onChange', 'onBlur'],
                rules: inp.rule
              }))(_react2.default.createElement(IInput, _extends({}, inp, { onChange: _this3.handleChange })))
            )
          );
        }),
        showIcon === false ? keys.length > 0 ? _react2.default.createElement(
          'span',
          null,
          '\xA0',
          _react2.default.createElement(_icon2.default, {
            style: { lineHeight: '32px' },
            type: 'minus-circle-o',
            disabled: disabled,
            onClick: function onClick() {
              return _this3.remove(k);
            }
          }),
          '\xA0',
          _react2.default.createElement(_icon2.default, {
            style: { lineHeight: '32px' },
            type: 'plus-circle-o',
            disabled: disabled,
            onClick: function onClick() {
              return _this3.add(index);
            }
          })
        ) : null : null
      ),
      _react2.default.createElement('hr', { style: { border: '1px dashed rgb(221, 221, 221)', width: '80%', display: showLine } })
    );
  };
}, _temp)) || _class);


//////////////////
// WEBPACK FOOTER
// ./src/components/complexInput/index.jsx
// module id = 79
// module chunks = 0